import React from 'react';

import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';

const StaticLink = ({
  links,
  children,
  defaultLocale = 'en',
  UserStore,
  className = ''
}) => {
  const link = links[UserStore.shortLocale] || links[defaultLocale];

  const stopPropagation = (e) => e.stopPropagation();

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={stopPropagation}
      className={className}
    >
      {children}
    </a>
  );
};

StaticLink.propTypes = {
  links: PropTypes.object,
  children: PropTypes.node,
  defaultLocale: PropTypes.string,
  className: PropTypes.string,
  UserStore: MobxPropTypes.objectOrObservableObject
};

export default inject('UserStore')(StaticLink);
